<template>
  <div v-if="l_visible">
    <v-combobox
      ref="control"
      class="dynamic-input-control"
      :data-id="dataId"
      :dense="dense"
      :hide-details="hideDetails"
      outlined
      :placeholder="placeholder"
      :menu-props="menuProps"
      :loading="isLoading || loading"
      :rules="getRules"
      :value="currentValue"
      :suffix="suffix"
      @focusout="onFocusOut"
      @focus="
        () => {
          isFocused = true;
        }
      "
      @change="onChange"
      :append-icon="getDisabled || isLoading || readonly ? '' : 'mdi-chevron-down'"
      :class="{
        validated: displayValidated && !hasError && !errorMessages,
        required: l_required,
        naked,
        readonly: readonly || getDisabled,
      }"
      :errorMessages="errorMessages"
      :disabled="getDisabled || isLoading || readonly"
      :items="data"
      no-filter
      :clearable="clearable"
      :readonly="readonly"
      item-text="displayMember"
      item-value="valueMember"
      :return-object="returnObject"
      hide-no-data
      @input="
        newVal => {
          setDirty(true);
          update(newVal);
        }
      "
      :search-input.sync="search"
    >
      <template v-slot:label>
        {{ getLabel }}
        <span v-if="optional" class="optional">(nepovinné)</span>
      </template>
      <template v-slot:append>
        <slot name="append"></slot>
        <v-tooltip v-if="!!getTooltip && !hideTooltip" bottom max-width="350">
          <template v-slot:activator="{ on }">
            <v-icon slot="activator" class="btn-help text-body-2 ml-2" v-on="on"
              >mdi-help-circle</v-icon
            >
          </template>
          <span> {{ getTooltip }} </span>
        </v-tooltip>
      </template>
      <div class="v-input__icon v-input__icon--append" v-if="getDisabled || isLoading || readonly? false : true">
        <v-icon>mdi-chevron-down</v-icon>
      </div>
    </v-combobox>
  </div>
</template>
<script>
import { dynamicControlMixin } from '../../mixins/dynamicControlMixin';

export default {
  mixins: [dynamicControlMixin],
  props: {
    value: [Number, String, Object],
    dense: Boolean,
    naked: Boolean,
    menuProps: Object,
    placeholder: String,
    source: String,
    optional: Boolean,
    suffix: String,
    disabled: {
      type: Boolean,
      default: false,
    },
    items: {
      type: Array,
      default: null,
    },
    clearable: Boolean,
    returnObject: Boolean,
    outerSearch: {
      type: Boolean,
      default: null,
    },
    loading: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      data: null,
      currentValue: this.value,
      isFocused: false,
      search: '',
    };
  },
  watch: {
    search(val) {
      if (this.isFocused) {
        this.$emit('search', val);
      }
    },
    value(val) {
      if (val === this.currentValue) return;
      this.update(val);
    },
    items(val) {
      this.data = val;
    },
  },
  computed: {
    getDisabled() {
      return this.disabled || this.isDisabled;
    },
  },
  methods: {
    onFocusOut() {
      this.isFocused = false;
      this.$emit('focusout');
      this.setDirty(true);
      this.update(this.search);
    },
    onChange(val) {
      this.setDirty(true);
      this.update(val);
    },
    readData(config, data) {
      if (this.dataId) {
        if (this.outerSearch) {
          this.data = this.items;
        } else {
          this.data = data;
        }

        if (config.controlValue || config.controlValue === 0) {
          this.update(config.controlValue);
          this.$emit('search', config.controlValue);
        } else if (this.currentValue) this.currentValue = null;
      } else {
        this.data = null; //res.data;
      }
    },
    update(newVal) {
      if (newVal === this.currentValue || newVal === this.currentValue?.valueMember) return;
      let primitiveValue;
      let emitValue = newVal;
      if (this.returnObject) {
        if (newVal !== Object(newVal)) {
          emitValue = this.data.find(d => d.valueMember?.toLowerCase() === newVal?.toLowerCase());
          if (emitValue) {
            primitiveValue = emitValue?.valueMember;
          } else {
            emitValue = newVal;
            primitiveValue = emitValue;
          }
        } else {
          primitiveValue = newVal.valueMember;
        }
      } else {
        primitiveValue = newVal;
      }
      this.currentValue = emitValue;

      this.$emit('input', emitValue);
      return this.saveValue(primitiveValue);
    },
    setValue(val) {
      if (val === this.currentValue || val === this.currentValue?.valueMember) return;
      this.currentValue = val;
      this.$emit('input', val);
      return this.saveValue(val, true);
    },
  },
  mounted() {
    if (this.items) this.data = this.items;
  },
  created() {
    this.data = [];

    if (!this.dataId && this.data.length === 0) {
      console.warn('Combobox nema zadane dataId ani data source!');
      return;
    }
  },
};
</script>
